// File: src/components/questionnaires/ParentShareHybrid.js
// -----------------------------------------------------------------------------
// Composant pour partager les résultats avec les parents
// 3 états: initial, loading, sent
// -----------------------------------------------------------------------------
import React, { useState } from 'react';
import { motion } from 'framer-motion';

export default function ParentShareHybrid({ onSendAgreement, agreed }) {
  const [screen, setScreen] = useState(agreed); // 'initial' | 'loading' | 'sent'

  const handleSend = async () => {
    setScreen('loading');
    try {
      await onSendAgreement();
      setScreen(true);
    } catch (error) {
      console.error('Erreur envoi agreement:', error);
      setScreen(false);
    }
  };

  return (
    <div className="mb-5 mx-auto">
      {/* ÉCRAN INITIAL */}
      {screen === false && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{
            background: 'rgba(30, 27, 75, 0.6)',
            border: '2px dashed rgba(251, 191, 36, 0.4)',
            borderRadius: '20px',
            padding: '32px 24px',
            textAlign: 'center'
          }}
        >
          {/* Titre */}
          <h2 className="text-2xl font-semibold text-white mb-3">
            Partager avec tes parents ?
          </h2>

          {/* Sous-titre accrocheur */}
          <p className="text-[15px] text-[#a5b4c4] mb-7 leading-relaxed">
            Des conseils pour les aider à mieux<br/>te comprendre et t'accompagner.
          </p>

          {/* Encart avec bullets */}
          <div
            style={{
              background: 'rgba(15, 10, 46, 0.5)',
              border: '1px solid rgba(139, 92, 246, 0.25)',
              borderRadius: '14px',
              padding: '18px',
              marginBottom: '28px',
              textAlign: 'left'
            }}
          >
            {/* Bullet 1 */}
            <div className="flex items-start gap-3 mb-3.5">
              <span className="text-base leading-relaxed">🔒</span>
              <p className="text-sm text-gray-300 m-0 leading-relaxed">
                Tes réponses détaillées restent confidentielles
              </p>
            </div>

            {/* Bullet 2 */}
            <div className="flex items-start gap-3">
              <span className="text-base leading-relaxed">🚫</span>
              <p className="text-sm text-gray-300 m-0 leading-relaxed">
                Pas de scores, pas de jugement - juste du positif
              </p>
            </div>
          </div>

          {/* Bouton principal */}
          <button
            onClick={handleSend}
            className="w-full py-4 px-6 rounded-[14px] text-[#1e1b4b] text-base font-semibold cursor-pointer transition-all hover:opacity-90"
            style={{
              background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
              border: 'none'
            }}
          >
            Générer la synthèse pour mes parents
          </button>
        </motion.div>
      )}

      {/* ÉCRAN LOADING */}
      {screen === 'loading' && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{
            background: 'rgba(30, 27, 75, 0.6)',
            border: '2px dashed rgba(251, 191, 36, 0.4)',
            borderRadius: '20px',
            padding: '48px 24px',
            textAlign: 'center'
          }}
        >
          <div
            className="mx-auto mb-5 animate-spin"
            style={{
              width: '48px',
              height: '48px',
              border: '3px solid rgba(251, 191, 36, 0.2)',
              borderTopColor: '#fbbf24',
              borderRadius: '50%'
            }}
          />
          <p className="text-[#a5b4c4] text-[15px] m-0">
            Génération en cours...
          </p>
        </motion.div>
      )}

      {/* ÉCRAN CONFIRMATION */}
      {screen === true && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          style={{
            background: 'rgba(30, 27, 75, 0.6)',
            border: '1px solid rgba(34, 197, 94, 0.3)',
            borderRadius: '20px',
            padding: '32px 24px',
            textAlign: 'center'
          }}
        >
          {/* Check */}
          <div
            className="mx-auto mb-5 flex items-center justify-center"
            style={{
              width: '56px',
              height: '56px',
              background: 'rgba(34, 197, 94, 0.2)',
              borderRadius: '50%'
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          </div>

          <h2 className="text-[22px] font-semibold text-white mb-5">
            Synthèse envoyée !
          </h2>

          {/* Encart réassurance post-envoi */}
          <div
            className="flex items-start gap-2.5 text-left"
            style={{
              background: 'rgba(34, 197, 94, 0.1)',
              border: '1px solid rgba(34, 197, 94, 0.2)',
              borderRadius: '12px',
              padding: '14px 16px'
            }}
          >
            <span className="text-sm">🔒</span>
            <p className="text-[13px] text-[#86efac] m-0 leading-relaxed">
              Pour rappel, tes réponses détaillées n'ont pas été partagées.
            </p>
          </div>
        </motion.div>
      )}
    </div>
  );
}
